'use client';
import { Accordion, AccordionItem, Link } from "@heroui/react"
import { categories, sources } from "@prisma/client"
import { Mgid } from "@/components/ads/Mgid";

type SiteMenuLayoutProps = {
  sources: sources[],
  categories: categories[],
}

export const SiteMenuLayout = ({
  sources,
  categories,
}: SiteMenuLayoutProps) => {

  return <>
    <Accordion defaultExpandedKeys={["1"]} selectionMode="multiple">
      <AccordionItem key="1" aria-label="Категорії" title="Категорії">
        <ul className="flex flex-col gap-2">
          {categories.map(category => (
            <li key={category.id}>
              <Link href={`/category/${category.id}`} className="text-default-500 hover:text-default-600">
                {category.name}
              </Link>
            </li>
          ))}
        </ul>
      </AccordionItem>
      <AccordionItem key="2" aria-label="Джерела" title="Джерела">
        <ul className="flex flex-col gap-2">
          {Array.isArray(sources) ? sources.map(source => (
            <li key={source.id}>
              <Link href={`/source/${source.id}`} className="text-default-500 hover:text-default-600">
                {source.name}
              </Link>
            </li>
          )) : <li>Немає джерел</li>}
        </ul>
      </AccordionItem>
    </Accordion>
    {/* <Mgid /> */}
  </>
}